import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'hansel-tag',
  templateUrl: './hansel-tags.component.html',
  styleUrls: ['./hansel-tags.component.scss']
})
export class HanselTagsComponent implements OnInit {

  @Input() style: any;
  @Input() class: any;
  @Input() headerIcon?: Boolean = false;
  @Input() tagType: string;
  @Input() tagTxt: string;
  @Input() noRemoveTag: any;
  @Output() tagRemoveCallback = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

  tagRemoveCicked(e, selectedTag) {
    const _param = { e: e, selectedTag: selectedTag };
    this.tagRemoveCallback.emit(_param);
  }

  getImgTxtTag(tagTxt) {
    if (!tagTxt) {
      return tagTxt;
    }
    const getTxtInitial = (txt) => {
      txt = txt.toUpperCase();
      const splitedtxt = txt.split(' ');
      return splitedtxt[0].slice(0, 1) + (splitedtxt[1] ? splitedtxt[1].slice(0, 1) : '');
    };

    const domainRegex = /([a-z0-9]+\.)*[a-z0-9]+\.[a-z]+/;
    const valueTobeReturn = domainRegex.test(tagTxt) ? 'img' : getTxtInitial(tagTxt);
    return valueTobeReturn;
  }
}
